<template>
  <div>
    <el-table :data="items">
      <el-table-column align="left" label="材料" prop="name" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.code }}（{{ scope.row.name }}，{{
            scope.row.specification
          }}，{{ scope.row.model_number }}）
        </template>
      </el-table-column>
      <el-table-column align="center" label="上次盘点时间" width="160">
        <template slot-scope="scope">{{
          scope.row.last_id
            ? $time(scope.row.last_created_at).format('YYYY-MM-DD')
            : '-'
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="上次盘点状态" width="160">
        <template slot-scope="scope">
          {{
            scope.row.last_inventory_result === null
              ? '-'
              : scope.row.last_inventory_result
          }}
          <br />
          {{ scope.row.last_remark }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="当前库存"
        prop="number"
        width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.number }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="本次盘点状态">
        <template slot-scope="scope">
          <template v-if="scope.row.edit == 2">
            <el-input
              v-model="scope.row.current_stock_number"
              size="small"
              type="number"
              placeholder="实际库存"
              class="m-b-5"
            ></el-input>
            <el-input
              v-model="scope.row.remark"
              type="textarea"
              autosize
              placeholder="备注"
            ></el-input>
          </template>
          <template v-else>
            {{ scope.row.current_stock_number || '-' }}
            <span
              v-if="scope.row.status == 1"
              :class="
                scope.row.inventory_result < 0 ? 'text-danger' : 'text-success'
              "
            >
              （{{ scope.row.inventory_result < 0 ? '' : '+'
              }}{{ scope.row.inventory_result }}）
            </span>
            <br />
            {{ scope.row.remark }}
          </template>
        </template>
      </el-table-column>
      <!-- <el-table-column label="盘点状态" align="center" prop="status">
      </el-table-column> -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <btn-tag
            v-if="scope.row.edit == 1"
            :auth-id="51302"
            :btn="true"
            text="盘点"
            module-name="stock"
            @click.native="changeItemEditStatus(scope.row, scope.$index)"
          ></btn-tag>
          <template v-else>
            <btn-tag
              :btn="true"
              :auth-id="51302"
              text="取消"
              module-name="stock"
              @click.native="changeItemEditStatus(scope.row, scope.$index)"
            ></btn-tag>
            <btn-tag
              :btn="true"
              :auth-id="51302"
              text="保存"
              module-name="stock"
              @click.native="editItemInventory(scope.row, scope.$index)"
            ></btn-tag>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { itemInventoryUpdate } from '@/service/getData'

export default {
  props: {
    items: null,
  },
  data() {
    return {}
  },
  methods: {
    changeItemEditStatus(item, index) {
      if (item.edit == 1) {
        item.original_stock_number = item.current_stock_number
        item.original_remark = item.remark
        item.current_stock_number = item.number
      } else {
        item.current_stock_number = item.original_stock_number
        item.remark = item.original_remark
      }
      item.edit = item.edit == 1 ? 2 : 1
      this.items[index] = item
    },
    async editItemInventory(item, index) {
      const data = {
        id: item.id,
        item_id: item.base_id,
        category: item.inventory_category,
        period: item.inventory_period,
        current_stock_number: parseInt(item.current_stock_number),
        inventory_result: parseInt(item.current_stock_number) - item.number,
        remark: item.remark,
      }
      let res = await itemInventoryUpdate(data)
      if (res.status == 0) {
        this.items[index].id = res.data.id
        this.items[index].edit = 1
        this.items[index].inventory_result = data.inventory_result
        this.$alert('操作成功！')
      }
    },
  },
}
</script>